import merge from 'lodash-es/merge';
import getDefaultStyle from '../css/defaultStyle';

export function getDefaultControlStyle() {
  if (!getDefaultControlStyle.style) {
    getDefaultControlStyle.style = {
      normal: merge({}, getDefaultStyle(), {
        boxSizing: 'border-box',
        transitionProperty: 'all',
        transitionDuration: '${schemeAnimationDuration}',
        transitionTimingFunction: 'ease',
        transitionDelay: '0s',
        position: 'absolute',
        top: '8px',
        left: '8px',
        width: '80px',
        height: '40px',
        padding: '20px',
        backgroundColor: '#333333',
        display: 'block',
        borderStyle: 'solid',
        borderColor: '#CCCCCC',
        borderWidth: '1px',
        borderRadius: '4px',
        boxShadow: '0px 0px 8px 3px #000000, 0px 0px 11px 3px rgba(0, 0, 0, 0.3) inset',
        overflow: 'auto',
      }),
    };
  }

  return getDefaultControlStyle.style;
}

export function getDefaultControl() {
  if (!getDefaultControl.source) {
    getDefaultControl.source = document.createElement('div');
    getDefaultControl.source.classList.add('controls');
    // getDefaultControl.source.style.opacity = 0;
    getDefaultControl.source.innerHTML =
      '<div class="body" style="top:0;right:0;bottom:0;left:0;width:100%;height:100%;overflow:auto;position:static;"></div>';

  }

  return getDefaultControl.source.cloneNode(true);
}
